let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("c5krk")).then(() => parcelRequire('b0kd3'));